var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoginbg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 772.235,
    height: 828.656,
    viewBox: "0 0 772.235 828.656",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_580",
    "data-name": "Path 580",
    d: "M-18.167,702.8H754.068V-125.858H-18.167Z",
    transform: "translate(18.167 125.858)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(18.167 125.858)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(-18.167 -125.858)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_565",
    "data-name": "Path 565",
    d: "M700.438,1309.822q46.016-40.206,92.032-80.431,36.286-31.72,72.573-63.466V-251.716Q837.686-227.59,810.3-203.5q-54.118,47.379-108.372,94.6c-24.414,21.378-48.63,43.006-73.056,64.378C593.057-13.174,557.047,17.95,521.247,49.323c-30.373,26.623-60.486,53.539-90.829,80.206q-56.071,49.273-112.31,98.359c-24.129,21.159-48.146,42.45-72.312,63.566q-44.807,39.137-89.756,78.1c-25.809,22.5-51.135,45.594-77.472,67.441-29.7,24.629-51.495,54.658-63.786,91.2C-1.353,576.177-4.645,625.06,6.715,674.8c9.68,42.384,27.093,80.3,59.978,109.607,21.531,19.184,43.4,37.987,65.075,57.015,24.123,21.178,48.14,42.463,72.294,63.6C234.448,931.6,265.008,958,295.369,984.623c24.941,21.872,49.622,44.063,74.576,65.916,30.107,26.367,60.493,52.414,90.575,78.812,30.888,27.123,61.5,54.589,92.354,81.756,37.889,33.355,76.065,66.391,113.811,99.909,15.72,13.958,15.36,14.365,31.211.831.825-.706,1.724-1.313,2.542-2.025",
    transform: "translate(112.657 -535.012)",
    fill: "#102250"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginbg);
export default __webpack_public_path__ + "static/media/loginbg.fa86d9fedc1f7ca1b4702bf6161da9cc.svg";
export { ForwardRef as ReactComponent };